import { StoreClockIcon } from './StoreClockIcon';

/**
 * author: Colton Wiscombe
 * id F1AABCBC-7F1F-4803-B2B9-CC5E8EF11FEE
 * name store-clock
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-clock.svg
 * tags
 * - Places 
 * - Shopping 
 */
export const StoreScheduleIcon = StoreClockIcon;
export default StoreScheduleIcon